import createAPI from '../axios'

// 资源申请模板管理 API
const teachingManagement = {
    projectApplication: {
        initCombo: config => createAPI('/teachingManagement/ProjectApplication/initCombo', 'post', config),
        save: config => createAPI('/teachingManagement/ProjectApplication/save', 'post', config),
        queryList: config => createAPI('/teachingManagement/ProjectApplication/queryList', 'post', config),
        queryRscList: config => createAPI('/teachingManagement/ProjectApplication/queryRscList', 'post', config),
        saveRec: config => createAPI('/teachingManagement/ProjectApplication/saveRec', 'post', config),
        deletefile: config => createAPI('/teachingManagement/ProjectApplication/deletefile', 'post', config),
        submit: config => createAPI('/teachingManagement/ProjectApplication/submit', 'post', config),
        del: config => createAPI('/teachingManagement/ProjectApplication/del', 'post', config),
        findSchedule: config => createAPI('/teachingManagement/ProjectApplication/findSchedule', 'post', config),
        initComboChild: config => createAPI('/teachingManagement/ProjectApplication/initComboChild', 'post', config),
        completeInspection: config => createAPI('/teachingManagement/ProjectApplication/completeInspection', 'post', config),
        saveRectification: config => createAPI('/teachingManagement/ProjectApplication/saveRectification', 'post', config),
        querySummaryStatisticsList: config => createAPI('/teachingManagement/ProjectApplication/querySummaryStatisticsList', 'post', config),
        notice: config => createAPI('/teachingManagement/ProjectApplication/notice', 'post', config),
    },
};

export default teachingManagement;



// WEBPACK FOOTER //
// ./src/api/modules/teachingManagement.js